import {
  Text,
  StyledLink,
  FormContainer,
  InputWrapper,
  ButtonLink,
} from "../components"
import Heading from "../heading"

const Invalid = () => (
  <FormContainer>
    <Heading rmaType="change-order" />
    <Text mb={3}>
      You have not selected any changes. If you need any further assistance,
      please{" "}
      <StyledLink color="black" data-lc="invalid" to="/helpdesk/contact">
        contact us
      </StyledLink>
      .
    </Text>

    <InputWrapper>
      <ButtonLink data-lc="invalid" to="/">
        Continue Shopping
      </ButtonLink>
    </InputWrapper>
  </FormContainer>
)

export default Invalid
